import { Link } from 'react-router-dom';

import React from 'react';

export default function CarsAgentsCategories() {
	return (
		<div>
			<div class='sp-banner'>
				<img
					src='assets/images/service-provider/cars-agents/banner.jpg'
					alt=''
					class='img-fluid sp-banner-img'
				/>
				<div class='sp-logo'>
					<div class='line-a'>
						<img
							src='assets/images/car-brands/mercedes-benz.jpg'
							alt=''
							class='img-fluid'
						/>
					</div>
					<div class='line-b'>Mercedes Benz</div>
				</div>
			</div>

			<div class='main-content-area'>
				<div class='container'>
					<div class='row justify-content-between'>
						<div class='col-12 col-sm-12 col-md-3 col-lg-3 mb-4 mb-sm-4 mb-md-0 mb-lg-0'>
							<div class='side-package'>
								<div class='line-a'>PACKAGE</div>
								<div class='line-b'>
									<div class='side-package-progress'>
										<span class='eighty'></span>
									</div>
								</div>
								<div class='line-c'>30 days remaining</div>
								<div class='line-d'>Validity till 02 March 2021</div>
								<div class='line-e'>
									<a class='btn btn-dark btn-sm' href='#' role='button'>
										UPDATE
									</a>
								</div>
							</div>

							<div class='side-links-wrap'>
								<ul>
									<li>
										<Link to='sp-cars-agents-business'>
											<img
												src='assets/images/icons/sp-business/manage-business.svg'
												alt=''
											/>{' '}
											Manage Business
										</Link>
									</li>
									<li>
										<Link to='sp-cars-agents-categories' class='active'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Categories
										</Link>
									</li>
									<li>
										<Link to='sp-cars-agents-cars'>
											<img
												src='assets/images/icons/sp-business/manage-service.svg'
												alt=''
											/>{' '}
											Manage Cars
										</Link>
									</li>
									<li>
										<Link to='sp-cars-agents-banner'>
											<img
												src='assets/images/icons/sp-business/banner.svg'
												alt=''
											/>{' '}
											Banner
										</Link>
									</li>
									<li>
										<Link to='/sp-cars-agents-working-hours'>
											<img
												src='assets/images/icons/sp-business/manage-working-hours.svg'
												alt=''
											/>{' '}
											Manage Working Hours
										</Link>
									</li>
									<li>
										<Link to='sp-cars-agents-showroom'>
											<img
												src='assets/images/service-icons/garage.svg'
												alt=''
											/>{' '}
											Manage Showroom
										</Link>
									</li>
									<li>
										<Link to='sp-cars-agents-workshop'>
											<img
												src='assets/images/service-icons/car-wash.svg'
												alt=''
											/>{' '}
											Manage Workshop
										</Link>
									</li>
								</ul>
							</div>
						</div>

						<div class='col-12 col-sm-12 col-md-9 col-lg-9'>
							<div class='row mb-4 align-items-center justify-content-between'>
								<div class='col'>
									<h3 class='mb-0'>Manage Categories</h3>
								</div>
								<div class='col-auto'>
									<a
										class='btn btn-outline-secondary'
										href='sp-cars-agents-manage-cars-add.html'
										data-toggle='modal'
										data-target='#category'>
										+ Add new Category
									</a>
								</div>
							</div>

							<div class='row'>
								<div class='col-6 col-sm-6 col-md-4 mb-5'>
									<div class='mc-add-car-block'>
										<div class='line-a'>
											<img
												src='assets/images/service-provider/cars-agents/a.jpg'
												class='img-fluid'
												alt=''
											/>
											<div class='line-d'>
												<div class='row'>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-edit'></i> Edit
														</a>
													</div>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-trash-alt'></i> Delete
														</a>
													</div>
													<div class='col-auto'>
														<a href='sp-cars-agents-manage-listings.html'>
															<i class='far fa-eye'></i> View
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class='line-b'>
											<div class='line-b'>
												<a href='sp-cars-agents-manage-listings.html'>
													A-Class
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class='col-6 col-sm-6 col-md-4 mb-5'>
									<div class='mc-add-car-block'>
										<div class='line-a'>
											<img
												src='assets/images/service-provider/cars-agents/b.jpg'
												class='img-fluid'
												alt=''
											/>
											<div class='line-d'>
												<div class='row'>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-edit'></i> Edit
														</a>
													</div>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-trash-alt'></i> Delete
														</a>
													</div>
													<div class='col-auto'>
														<a href='sp-cars-agents-manage-listings.html'>
															<i class='far fa-eye'></i> View
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class='line-b'>
											<div class='line-b'>
												<a href='sp-cars-agents-manage-listings.html'>
													B-Class
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class='col-6 col-sm-6 col-md-4 mb-5'>
									<div class='mc-add-car-block'>
										<div class='line-a'>
											<img
												src='assets/images/service-provider/cars-agents/c.jpg'
												class='img-fluid'
												alt=''
											/>
											<div class='line-d'>
												<div class='row'>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-edit'></i> Edit
														</a>
													</div>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-trash-alt'></i> Delete
														</a>
													</div>
													<div class='col-auto'>
														<a href='sp-cars-agents-manage-listings.html'>
															<i class='far fa-eye'></i> View
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class='line-b'>
											<div class='line-b'>
												<a href='sp-cars-agents-manage-listings.html'>
													C-Class
												</a>
											</div>
										</div>
									</div>
								</div>

								<div class='col-6 col-sm-6 col-md-4 mb-5'>
									<div class='mc-add-car-block'>
										<div class='line-a'>
											<img
												src='assets/images/service-provider/cars-agents/d.jpg'
												class='img-fluid'
												alt=''
											/>
											<div class='line-d'>
												<div class='row'>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-edit'></i> Edit
														</a>
													</div>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-trash-alt'></i> Delete
														</a>
													</div>
													<div class='col-auto'>
														<a href='sp-cars-agents-manage-listings.html'>
															<i class='far fa-eye'></i> View
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class='line-b'>
											<div class='line-b'>
												<a href='sp-cars-agents-manage-listings.html'>CLA</a>
											</div>
										</div>
									</div>
								</div>

								<div class='col-6 col-sm-6 col-md-4 mb-5'>
									<div class='mc-add-car-block'>
										<div class='line-a'>
											<img
												src='assets/images/service-provider/cars-agents/e.jpg'
												class='img-fluid'
												alt=''
											/>
											<div class='line-d'>
												<div class='row'>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-edit'></i> Edit
														</a>
													</div>
													<div class='col-auto'>
														<a href='#'>
															<i class='far fa-trash-alt'></i> Delete
														</a>
													</div>
													<div class='col-auto'>
														<a href='sp-cars-agents-manage-listings.html'>
															<i class='far fa-eye'></i> View
														</a>
													</div>
												</div>
											</div>
										</div>
										<div class='line-b'>
											<div class='line-b'>
												<a href='sp-cars-agents-manage-listings.html'>EQA</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
